import React from 'react';

export const InProgressIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <circle cx="10" cy="10" r="10" fill="#F8C437" />
      <path fill="#FFF" fillRule="nonzero" d="M16.681 9.628c0 .899-.729 1.628-1.628 1.628-.899 0-1.628-.729-1.628-1.628 0-.9.73-1.628 1.628-1.628.9 0 1.628.729 1.628 1.628zm-5.21 0c0 .899-.728 1.628-1.627 1.628-.9 0-1.628-.729-1.628-1.628 0-.9.729-1.628 1.628-1.628.432 0 .846.171 1.151.477.305.305.477.72.477 1.15zM4.636 8c.899 0 1.628.729 1.628 1.628 0 .899-.73 1.628-1.628 1.628-.9 0-1.628-.729-1.628-1.628 0-.9.729-1.628 1.628-1.628z" />
    </g>
  </svg>
);
export default InProgressIcon;
